<template>
  <a-spin :spinning="confirmLoading">
    <a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-row>
        <a-col :span="24">
          <a-form-item label="权益分类">
            <a-select
              style="width: 155px"
              placeholder="请选择权益分类"
              v-decorator="[
                'benefitType',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择权益分类',
                    },
                  ],
                },
              ]"
            >
              <a-select-option
                v-for="item in benefitTypeOptions"
                :key="item.value"
                :value="item.value"
                >{{ item.text }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="权益名称">
            <a-input
              size="large"
              :max-length="100"
              placeholder="请输入权益名称"
              v-decorator="[
                'name',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入权益名称,不超过100个字',
                    },
                  ],
                },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="icon">
            <UploadImage :imgUrl="iconUrl" @handleFileList="handleImageList" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="权益说明">
            <a-input
              placeholder="请输入权益说明"
              style="width: 100%"
              :max-length="200"
              v-decorator="['description']"
            />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="排序">
            <a-input-number :min="0" v-decorator="['idx']" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-spin>
</template>

<script>
import { jsonAction, postAction, getAction } from '@/api/manage';
import UploadImage from '@/components/common/UploadImage';

export default {
  name: 'EquityPoolForm',
  components: {
    UploadImage,
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    benefitTypeOptions: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      model: {
        idx: 1,
      },
      iconUrl: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      url: {
        add: process.env.VUE_APP_CMS_CUSTOMER + '/member/ctMmBenefits/add',
        edit: process.env.VUE_APP_CMS_CUSTOMER + '/member/ctMmBenefits/edit',
        queryById:
          process.env.VUE_APP_CMS_CUSTOMER + '/member/ctMmBenefits/queryById',
      },imgFile: {}
    };
  },
  computed: {
    formDisabled() {
      return this.disabled;
    },
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model));
  },
  methods: {
    handleImageList(file) {
      this.imgFile = file;
      this.iconUrl = file.fileUrl;
    },
    add() {
      this.$nextTick(() => {
        this.form.setFieldsValue(this.modelDefault);
      });
    },
    edit(record) {
      this.id = record.id;
      let params = {
        id: record.id,
      };
      getAction(this.url.queryById, params).then((res) => {
        if (res.success) {
          this.iconUrl = res.result.icon;
          this.$nextTick(() => {
            this.model = res.result;
            this.iconUrl = res.result.previewUrl;
            this.form.setFieldsValue({
              benefitType: res.result.benefitType + '',
              description: res.result.description,
              icon: res.result.icon,
              name: res.result.name,
              idx: res.result.idx || 1,
            });
          });
        }
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    submitForm() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        this.model = {};
        let formData = Object.assign(this.model, values);
        formData.icon = this.imgFile.fileName;
        if (!err) {
          let httpurl = '';
          let method = 'post';
          if (!this.id) {
            httpurl += this.url.add;
          } else {
            formData.id = this.id;
            httpurl += this.url.edit;
          }
          jsonAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                that.confirmLoading = false;
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped></style>
